<template>
  <div>
    <ConductorApiSelect />
    <nav>
      <ul>
        <li>
          <router-link :to="{ name: 'workflowList' }">Workflows</router-link>
          <router-link
            v-if="!readOnly"
            tag="button"
            :to="{ name: 'workflowCreate' }"
          >
            Create
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'taskQueueList' }">Queues</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'taskList' }">Tasks</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'taskDefinitionList' }">
            Task Definitions
          </router-link>
          <router-link
            v-if="!readOnly"
            tag="button"
            :to="{ name: 'taskDefinitionCreate' }"
          >
            Create
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'workflowDefinitionList' }">
            Workflow Definitions
          </router-link>
          <router-link
            v-if="!readOnly"
            tag="button"
            :to="{ name: 'workflowDefinitionCreate' }"
          >
            Create
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'eventHandlerList' }">
            Event Handlers
          </router-link>
          <router-link
            v-if="!readOnly"
            tag="button"
            :to="{ name: 'eventHandlerCreate' }"
          >
            Create
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'conductorApiConfig' }">
            Configuration
          </router-link>
        </li>
      </ul>
    </nav>
    <MessageList />
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ConductorApiSelect from '@/components/ConductorApiSelect.vue'
import MessageList from '@/components/MessageList.vue'

export default {
  name: 'ConductorApiView',
  computed: mapState(['readOnly']),
  components: {
    MessageList,
    ConductorApiSelect
  }
}
</script>

<style scoped>
ul {
  list-style-type: none;
  margin-left: 0px;
  text-align: center;
}
li {
  display: inline;
}
li:after {
  content: ' | ';
}
li:last-child:after {
  content: '';
}
li a {
  text-decoration: none;
  color: inherit;
}
</style>
